import {useTranslation} from "react-i18next";
import style from "../style/registration.module.scss";
import React, {useEffect, useState} from "react";
import {CounselorCheckboxField} from "./CounselorCheckboxField";
import {CounselorShortTextField} from "./CounselorShortTextField";
import {AddedFile, FileType} from "../../../types/file";
import {CounselorImageField} from "./CounselorImageField";
import {CounselorLongInputField} from "./CounselorLongInputField";
import {CounselorCheckOptions, CounselorDuplicateType, TaxSelectedValue} from "../../../types/counselor";
import {CounselorDuplicateCheckButtonFiled} from "./CounselorDuplicateCheckButtonFiled";
import {CounselorAffiliationSelector} from "./CounselorAffiliationSelector";
import {useCounselorStore} from "./hooks/counselorStore";

interface Args {
    title?: string
}

export function CounselorField({title,}: Args) {

    /**
     * 상담관리자 정보 영역
     */
    const {t} = useTranslation("counselorGroup");
    const KOR_CODE = "+82";
    const {counselorDTO, setCounselorDTO, validates, setValidate} = useCounselorStore();

    const [thumbnail, setThumbnail] = useState<AddedFile>();
    const [profileImage, setProfileImage] = useState<FileType | undefined>();
    const [counselorGroup, setCounselorGroup] = useState('');
    const [isVatInclude, setIsVatInclude]
        = useState(counselorDTO.isVatInclude ? TaxSelectedValue.SELECT : TaxSelectedValue.UNSELECT);
    const [isTaxDeducted, setIsTaxDeducted]
        = useState(counselorDTO.isTaxDeduction ? TaxSelectedValue.SELECT : TaxSelectedValue.UNSELECT);

    const CELLPHONE_MIN_LENGTH = counselorDTO.codePhone === KOR_CODE ? 11 : 5
    const CELLPHONE_MAX_LENGTH = counselorDTO.codePhone === KOR_CODE ? 11 : 15

    // 소속 등록인지 상담사 등록인지 분리 (true인 경우 => 상담사 등록 / false => 상담소속 등록)
    const isCounselorRegistration = !title;

    useEffect(() => {
        if (setCounselorDTO) {
            setCounselorDTO(counselorDTO)
        }
        //eslint-disable-next-line
    }, [isVatInclude, isTaxDeducted]);

    useEffect(() => {
        setCounselorDTO({...counselorDTO, addedImage: profileImage})
        //eslint-disable-next-line
    }, [profileImage]);

    useEffect(() => {
        setCounselorDTO({
            ...counselorDTO,
            isVatInclude: isVatInclude === TaxSelectedValue.SELECT,
            isTaxDeduction: isTaxDeducted === TaxSelectedValue.SELECT
        });

        //eslint-disable-next-line
    }, [isVatInclude, isTaxDeducted]);


    return (
        <>
            {/*  조건부 제목 수정필요  */}
            {!isCounselorRegistration && (<span className={style.mainTitle}>{title}</span>
            )}

            {/*  국적 영역  */}
            <CounselorCheckboxField
                label={t("registration.counselor.nationality")}
                isRequired={true}
                placeHolder={t('registration.nationalityPlaceHolder')}
                checkboxOption={CounselorCheckOptions.COUNTRY}
                option={counselorDTO.nationality}
                setOption={(value) => setCounselorDTO({...counselorDTO, nationality: value})}
            >
            </CounselorCheckboxField>

            {/*  아이디  */}
            <CounselorDuplicateCheckButtonFiled
                duplicateType={CounselorDuplicateType.EMAIL}
                minLength={6} maxLength={60}
                label={t('registration.counselor.id')}
                placeHolder={t('registration.idPlaceHolder')}
                isLabelVisible={true}
                value={counselorDTO.email}
                setValue={(value) => setCounselorDTO({...counselorDTO, email: value})}
                validate={validates.id}
                setValidate={(status) => setValidate('id', status)}
            />

            {/*  이름  */}
            <CounselorShortTextField
                label={t('registration.counselor.name')}
                placeHolder={t('registration.namePlaceHolder')}
                inputType={'text'}
                minLength={2} maxLength={50}
                isRequired={true} isLabelVisible={true}
                value={counselorDTO.name}
                setValue={(value) => setCounselorDTO({...counselorDTO, name: value})}
                validate={validates.name}
                setValidate={(status) => setValidate('name', status)}
            />

            {/*  휴대폰번호  */}
            <CounselorCheckboxField
                label={t('registration.counselor.codePhone')}
                isRequired={true} placeHolder={''}
                checkboxOption={CounselorCheckOptions.NATIONALITY}
                option={counselorDTO.codePhone}
                setOption={(value) => setCounselorDTO({...counselorDTO, codePhone: value})}
            >
                <CounselorDuplicateCheckButtonFiled
                    duplicateType={CounselorDuplicateType.CELL_PHONE}
                    minLength={CELLPHONE_MIN_LENGTH} maxLength={CELLPHONE_MAX_LENGTH} label={''}
                    placeHolder={t('registration.cellPhoneLengthPlaceHolder')}
                    isLabelVisible={false}
                    value={counselorDTO.phoneNumber}
                    setValue={(value) => setCounselorDTO({...counselorDTO, phoneNumber: value})}
                    subValue={counselorDTO.codePhone}
                    validate={validates.cellPhone}
                    setValidate={(status) => setValidate('cellPhone', status)}
                />
            </CounselorCheckboxField>

            {/*  비밀번호  */}
            <CounselorShortTextField
                label={t('registration.counselor.password')}
                placeHolder={t('registration.passwordPlaceHolder')}
                inputType={'password'}
                minLength={8} maxLength={16}
                isRequired={true} isLabelVisible={true}
                additionalText={'영문 대소문자/숫자/특수문자를 조합한 8~16자리 입력'}
                value={counselorDTO.password}
                setValue={(value) => setCounselorDTO({...counselorDTO, password: value})}
                validate={validates.password}
                setValidate={(status) => setValidate('password', status)}
            />

            {/*  비밀번호 확인  */}
            <CounselorShortTextField
                label={t('registration.counselor.passwordConfirm')}
                placeHolder={t('registration.passwordPlaceHolder')}
                inputType={'password'}
                minLength={8} maxLength={16}
                isRequired={true} isLabelVisible={true}
                value={counselorDTO.passwordConfirm ?? ""}
                setValue={(value) => setCounselorDTO({...counselorDTO, passwordConfirm: value})}
                validate={validates.passwordConfirm}
                setValidate={(status) => setValidate('passwordConfirm', status)}
            />

            {/*  프로필 이미지  */}
            <CounselorImageField
                thumbnail={thumbnail} setThumbnail={setThumbnail}
                addedProfileImage={profileImage}
                setAddedProfileImage={setProfileImage}/>

            {/*  상담사 약력  */}
            <CounselorLongInputField
                label={t('registration.counselor.counselorProfile')}
                placeHolder={t('registration.counselorPlaceHolder')}
                isRequired={false}
                value={counselorDTO.briefHistory}
                setValue={(value) => setCounselorDTO({...counselorDTO, briefHistory: value})}
            />

            {/*  계좌정보  */}
            <CounselorCheckboxField
                label={t('registration.counselor.accountInfo')}
                placeHolder={t('registration.accountPlaceHolder')}
                isRequired={false}
                additionalText={"정산 받으실 은행을 선택해주세요."}
                checkboxOption={CounselorCheckOptions.ACCOUNT}
                option={counselorDTO.bankName}
                setOption={(value) => setCounselorDTO({...counselorDTO, bankName: value})}
            >
                <div className={style.childrenWrapper}>
                    <CounselorShortTextField
                        label={''}
                        placeHolder={(t('registration.accountNumberPlaceHolder'))}
                        inputType={'number'}
                        minLength={7} maxLength={20}
                        isRequired={true}
                        isLabelVisible={false}
                        value={counselorDTO.accountNumber}
                        setValue={(value) => setCounselorDTO({...counselorDTO, accountNumber: value})}
                    />
                    <CounselorShortTextField
                        label={''}
                        placeHolder={(t('registration.accountNamePlaceHolder'))}
                        inputType={'text'}
                        minLength={2} maxLength={20}
                        isRequired={true}
                        isLabelVisible={false}
                        value={counselorDTO.accountName}
                        setValue={(value) => setCounselorDTO({...counselorDTO, accountName: value})}
                    />
                </div>

                {/*  상담소속 선택  */}
                {isCounselorRegistration && (
                    <CounselorAffiliationSelector
                        isVatInclude={isVatInclude} setIsVatInclude={setIsVatInclude}
                        isTaxDeducted={isTaxDeducted} setIsTaxDeducted={setIsTaxDeducted}
                        counselorGroup={counselorGroup} setCounselorGroup={setCounselorGroup}
                    />
                )}
            </CounselorCheckboxField>
        </>
    );
}